/** @format */

import { axiosCalls } from '../../config/AxiosCall';

const url = 'Constants';

export async function fetchApplicationDates() {
  return axiosCalls.get(`${url}/get-set-application-dates`);
}
